import moment from "moment";

export const rmBuddiesInitialState = {
  currentWarehouseId: null,
  rmBuddiesList: null,
  visibleRmBuddiesList: null,
  buddyBlocksList: null,
  rmBuddiesFilter: {
    searchQuery: "",
    buddyBlockId: null
  },
  tasksDueDateFilter: {
    fromDate: moment().endOf("day"),
    toDate: moment().endOf("day")
  },
  tasksTypeFilter: null,
  tasksStatusTagFilter: null
};
